// import apiFetch from '@wordpress/api-fetch';
// import { EventMiddleware } from 'event-middleware/Event-Middleware';
import { InteractableController } from 'interactable-controller/InteractableController';
import AnchorInterceptor from '@tjseabury/anchor-interceptor';


class MobileNavigationAccordianSubMenu extends InteractableController {
    constructor( control, interactable, options = {
        className: 'accordian-item-active',
        closeOnScroll: false,
        closeOnOutside: false
    } ) {
        super( control, interactable, options );

        const subMenu = interactable.querySelector( '.sub-menu' );
        if ( !subMenu ) throw new Error( 'HTML incompatible.', interactable );
        subMenu.classList.add( 'accordian-sub-menu' );
        this.openHeight = subMenu.getBoundingClientRect().height;

        subMenu.style.setProperty(
            '--open-height',
            String( this.openHeight + 'px' )
        );
        subMenu.style.setProperty(
            '--close-height',
            '0px'
        );
    }
}

class MobileNavigationAccordianMenu {
    constructor( theAccordianElement ) {
        this.subMenus = [];

        theAccordianElement.classList.add( 'accordian-menu' );

        const subMenus = Array.from( theAccordianElement.querySelectorAll( '.menu > .menu-item-has-children' ) );
        if ( !subMenus ) throw new Error( 'No elements to build accordian from.', subMenus, selector );

        for ( const menu of subMenus ) {
            const control = document.createElement( 'div' );
            control.classList.add( 'control' );
            control.innerHTML = '<i class="fas fa-plus"></i>';
            menu.append( control );

            try {
                this.subMenus.push(
                    new MobileNavigationAccordianSubMenu( control, menu, {
                        className: 'accordian-item-active',
                        closeOnScroll: false,
                        closeOnOutside: true
                    } )
                );
            } catch ( err ) {
                throw new Error( err );
            }
        }
    }
}

( ( W, D, H, B ) => {

    function isIterable ( obj ) {
        if ( obj == null ) {
            return false;
        }
        return typeof obj[Symbol.iterator] === 'function';
    }

    class UniqueName {
        static i = 0;
        static next ( name = '' ) {
            return String( name + this.i++ );
        }
    }

    /**
     * Returns a number whose value is limited to the given range.
     *
     * Example: limit the output of this computation to between 0 and 255
     * (x * 255).clamp(0, 255)
     *
     * @param {Number} min The lower boundary of the output range
     * @param {Number} max The upper boundary of the output range
     * @returns A number in the range [min, max]
     * @type Number
     */
    Number.prototype.clamp = function ( min = -1, max = 1 ) {
        return Math.min( Math.max( this, min ), max );
    };

    function Singleton ( constructor = () => new Object() ) {
        let instance = null;
        function getInstance () {
            if ( null === instance ) {
                instance = construct();
            }
        }
        function construct () {
            return new constructor();
        }
        return {
            getInstance: getInstance
        };
    }

    /**
     * Tests if an object is an Element.
     * @param {Object} obj 
     * @returns {Boolean} True if obj is defined, not null,
     * and is an instance of the Element interface.
     */
    function isElement ( obj ) {
        return (
            undefined !== obj &&
            null !== obj &&
            obj instanceof Element
        );
    }

    /**
     * Attaches a LiveRect to an element that allows for performant 
     * access to the element's bounding box properties.
     * @param {Element} element 
     * @returns false if error, otherwise true.
     */
    function attachLiveRect ( element ) {
        // Enforce element is provided and valid.
        if ( !isElement( element ) ) {
            console.error( `${attachLiveRect.name}() requires an <Element>!` );
            return false;
        }

        const buildThresholdList = () => {
            const thresholds = [];
            const step = 1 / ( element.getBoundingClientRect().height * 100 );
            for ( let i = 0; i <= 1; i += step ) {
                thresholds.push( i );
            }
            return thresholds;
        };

        /**
         * Accomplishes encapsulation by using scope hiding
         * to approximate private properties with accessor methods.
         * @returns An object containing public methods.
         */
        function LiveRect () {
            // private
            let bounds = null;

            // private
            const observer = new IntersectionObserver( ( entries ) => {
                if ( entries[0] && entries[0].boundingClientRect ) {
                    bounds = entries[0].boundingClientRect;
                }
            }, {
                root: null,
                rootMargin: "0px",
                threshold: buildThresholdList()
            } );
            observer.observe( element );

            /**
             * Public accessor method for bounds.
             * @returns The bounding client rect object.
             */
            function rect () {
                if ( null === bounds ) {
                    return element.getBoundingClientRect();
                }
                return element.getBoundingClientRect();
            }

            /**
             * Public method to stop observing and cleanup.
             */
            function detach () {
                observer.disconnect();
                liveRect = null;
            }

            // The public api.
            return {
                rect: rect,
                detach: detach
            };
        }

        // Instantiate a LiveRect and attach to the element.
        element.liveRect = new LiveRect();
        return true;
    }

    /**
     * Initializes a LiveRect on the element if needed and
     * gets the element's bounding client rect object.
     * @param {Element} element 
     * @returns {Object} The element's bounding rect, 
     * or false if the element is invalid.
     */
    function maybeInitAndGetRect ( element ) {
        if ( !isElement( element ) ) return false;
        if ( !element.liveRect || 'function' !== typeof element.liveRect.rect ) {
            attachLiveRect( element );
        }
        return element.liveRect.rect();
    }

    /**
     * Determines the relative distance ratio of an element's center line
     * in relation to the viewport's centerline along the y-axis where
     * the ratio is negative when the element is above the viewport's centerline
     * and positive below.
     * @param {Element} element 
     * @returns {Number} The ratio, or zero if error.
     */
    function relativePositionToViewport ( element ) {
        if ( !isElement( element ) ) return 0;
        const rect = maybeInitAndGetRect( element );
        /**
         * Find the relative distance of the element's y center line 
         * to the window's y center line using:
         * (h + 2t)/w - 1
         * or
         * (h + 2t - w)/w
         * where
         * h = element rect height
         * t = element rect top
         * w = window height
         */
        const h = rect.height;
        const t = rect.top;
        const w = H.wh;
        return ( h + 2 * t ) / w - 1;
    }
    async function asyncRelativePositionToViewport ( element ) {
        return relativePositionToViewport( element );
    }

    function relativeSizeToViewport ( element ) {
        if ( !isElement( element ) ) return 0;
        const rect = maybeInitAndGetRect( element );
        return H.wh / rect.height;
    }

    function inverseRelativeSizeToViewport ( element ) {
        if ( !isElement( element ) ) return 0;
        const rect = maybeInitAndGetRect( element );
        return rect.height / H.wh;
    }

    function setCssVarInverseRelativeSiveToViewport ( element ) {
        const ratio = inverseRelativeSizeToViewport( element );
        element.style.setProperty( '--iRSTOV', String( ratio ) );
    }

    function setCssVarHeight ( element ) {
        const rect = maybeInitAndGetRect( element );
        element.style.setProperty( '--height', String( rect.height ) + 'px' );
    }

    function fadeInOut ( element, f = x => x ) {
        let pos = relativePositionToViewport( element );
        let r = f( Math.abs( pos.clamp() ) );
        element.style.setProperty( 'filter', 'opacity(' + ( 1 - r ) + ')' );
        return r;
    }

    async function simpleParallax ( element ) {
        let pos = await asyncRelativePositionToViewport( element );
        pos = pos.clamp( -2, 2 );
        element.style.setProperty( '--parallax-factor', String( -pos ) );
        setCssVarInverseRelativeSiveToViewport( element );
    }

    function angel ( className ) {
        const angel = D.createElement( 'div' );
        angel.classList.add( 'angel' );
        if ( className ) {
            angel.classList.add( className );
        }
        /* window.addEventListener(
            'resize',
            setRelativeTransformVars.bind(
                null,
                angel
            )
        ); */
        return angel;
    }

    function setRelativeTransformVars ( angel ) {
        const round = ( n, p = 2 ) => Math.round( ( n + Number.EPSILON ) * 10 ** p ) / 10 ** p;
        const degToRad = ( a ) => a * Math.PI / 180;
        const rect = angel.getBoundingClientRect();
        const styles = getComputedStyle( angel );
        const alpha = styles.getPropertyValue( '--rotate-z' );
        const width = rect.width;
        const height = rect.height;
        const beta = 90 - Math.abs( parseFloat( alpha ) );

        const x = parseFloat( styles.getPropertyValue( '--translate-x' ) );
        const hypotenuse = ( height / 2 ) / height * 100;
        const opposite = Math.sin( degToRad( beta ) ) * hypotenuse;
        const adjacent = Math.cos( degToRad( beta ) ) * hypotenuse;
        const relX = ( x / width * 100 ) - adjacent;
        const relY = opposite;
        console.log( '--rel-x', `${round( relX )}%` );
        console.log( '--rel-y', `${round( relY )}%` );
        angel.style.setProperty( '--rel-x', `${round( relX )}%` );
        angel.style.setProperty( '--rel-y', `${round( relY )}%` );
        /* requestAnimationFrame( setRelativeTransformVars.bind(
            null,
            angel
        ) ); */
    }

    function makeDismissable ( element, controlSelector = '.dismissable-control' ) {
        // Grab notification element or fail.
        const control = element.querySelector( controlSelector );
        if ( !control ) {
            console.error( 'Dismissables must contain a control element.' );
            return;
        }
        // Get it's ID or fail
        const id = element.getAttribute( 'data-id' );
        if ( !id ) {
            console.error( 'Dismissables must have a data-id.' );
            return;
        }
        // Check id against session token state.
        const state = W.sessionStorage.getItem( id );
        if ( 'dismissed' === state ) {
            element.style.setProperty( 'display', 'none' );
        }
        control.addEventListener(
            'click',
            ev => {
                ev.preventDefault();
                W.sessionStorage.setItem( id, 'dismissed' );
                element.style.setProperty( 'display', 'none' );
            }
        );
    }

    /**
     * Has registered animation functions and loops through them 
     * once every animation frame.
     * @returns The animation loop object.
     */
    function animationLoop () {
        // Storing the animation functions here to be called in the loop.
        const animations = {};

        let scrolled = false;
        window.addEventListener( 'scroll', () => { scrolled = true; }, {
            passive: true
        } );

        /**
         * Obviously the main loop.
         */
        function render () {
            // Loop through and execute each animation function.
            for ( const [name, animation] of entries() ) {
                animation( scrolled );
            }
            scrolled = false;
            requestAnimationFrame( render );
        }

        /**
         * @returns The animation names.
         */
        function keys () {
            return Object.keys( animations );
        }

        /**
         * @returns The name, animation pairs.
         */
        function entries () {
            return Object.entries( animations );
        }

        /**
         * Register a named animation to the animation loop.
         * @param {string} name 
         * @param {function} animation 
         * @returns false on error, otherwise true.
         */
        function register ( name, animation ) {
            if ( 'function' !== typeof animation ) {
                console.error( 'Animation loop must be provided a function!' );
                return false;
            }
            animations[name] = animation;
            return true;
        }

        /**
         * Deregister an animation by name.
         * @param {string} name 
         * @returns true on success, otherwise false.
         */
        function deregister ( name ) {
            if ( keys().includes( name ) ) {
                delete animations[name];
                return true;
            }
            return false;
        }

        // Start the loop!
        requestAnimationFrame( render );

        /**
         * Give appropriate public access to functions and properties.
         */
        return {
            names: keys,
            animations: entries,
            register: register,
            deregister: deregister
        };
    }

    initializeGlobalVariables();

    let parallaxables = null;

    W.addEventListener( 'resize', onResize );

    W.addEventListener( 'DOMContentLoaded', () => {

        W.dispatchEvent( new Event( 'resize' ) );
        W.dispatchEvent( new Event( 'scroll' ) );

        function cascadeAction ( root, action ) {
            if ( !root ) return;
            action( root );
            if ( root.childNodes.length < 1 ) return;
            for ( const n of root.childNodes ) {
                cascadeAction( n, action );
            }
        }
        function jsInlineDynamicDate ( node ) {
            if ( '#text' !== node.nodeName ) return;
            const reg = /{{js-todays-date}}/gm;
            const match = reg.exec( node.textContent );
            if ( !match ) return;
            node.textContent = node.textContent.replace( reg, new Date().toLocaleDateString() );
        }
        const dynamicDates = Array.from( D.querySelectorAll( '.js-todays-date-inline' ) );
        for ( const date of dynamicDates ) {
            cascadeAction( date, jsInlineDynamicDate );
        }

        let angelables = Array.from( H.querySelectorAll( '.hasAngels' ) );
        for ( const angelHolder of angelables ) {
            let transformWrapper = D.createElement( 'div' );
            transformWrapper.classList.add( 'transform-wrapper' );
            transformWrapper.classList.add( 'parallaxable' );
            let angel1 = angel( 'bottom' );
            transformWrapper.append( angel1 );
            let angel2 = angel( 'top' );
            angel2.append( angel() );
            transformWrapper.append( angel2 );
            angelHolder.append( transformWrapper );
        }

        parallaxables = Array.from(
            H.querySelectorAll(
                '.parallax-root, .hasAngels'
            )
        );

        const aniLoop = animationLoop();

        function animateParallax ( element, scrolled = false ) {
            // check if we need to animate.
            // did a scroll happen?
            // is the element in view? (is this an expensive check?)
            if ( scrolled ) {
                simpleParallax( element );
            }
        }

        if ( isIterable( parallaxables ) ) {
            for ( const el of parallaxables ) {
                aniLoop.register(
                    UniqueName.next( 'parallax' ),
                    animateParallax.bind( null, el )
                );
            }
        }


        const interceptor = new AnchorInterceptor(
            '#masthead.site-header',
            [
                '.knockout-button',
                '.smoothScrollThis a[href*="#"]',
                '.js-smooth-scroll'
            ]
        );
        if ( interceptor.checkForTarget() ) {
            window.addEventListener( 'load', () => {
                interceptor.doAnimate( interceptor.getTarget() );
            } );
        }
        window.addEventListener( 'click', ( ev ) => {
            interceptor.clickHandler( ev );
        } );



        /**
         * This really only applies to the Lending Officers page but I wrote it to be used anywhere-ish.
         */
        const randomizeThese = document.querySelectorAll( '.js-randomize-item-order ul.wp-block-post-template' );
        const badRandomizer = ( parent ) => {
            let max = parent.children.length - 1;
            for ( let i = 0; i < Math.floor( Math.random() * 1000 ); ++i ) {
                let k = Math.round( Math.random() * max );
                const temp = parent.removeChild( parent.children[k] );
                parent.append( temp );
            }
        };
        for ( const element of randomizeThese ) {
            badRandomizer( element );
        }


        /**
         * Initialize dismisables if they exist.
         */
        const dismisables = Array.from( H.querySelectorAll( '.dismissable' ) );
        dismisables.map( d => {
            makeDismissable( d );
        } );

    } );

    function insertTodaysDate ( element ) {
        let date = new Date().toLocaleDateString();
        element.innerHTML = date;
    }

    W.addEventListener( 'load', onLoad );

    function onLoad () {
        W.dispatchEvent( new Event( 'resize' ) );
        W.dispatchEvent( new Event( 'scroll' ) );

        /**
         * Initialize the login menu.
         */
        const loginButton = H.querySelector( '.site-header #banking-login-buttons .login' );
        const loginMenu = H.querySelector( '.site-header #banking-login-buttons .login-navigation' );
        let loginMenuController = null;
        if ( loginButton ) {
            loginMenuController = new InteractableController(
                loginButton,
                loginMenu,
                {
                    className: 'nav-open',
                    closeOnScroll: true,
                    closeOnOutside: true,
                }
            );
        }

        if ( H.clientWidth <= 1024 ) {
            /**
             * Initialize the mobile nav menu.
             */
            const mobileNavButton = H.querySelector( '.site-header > .menu-toggle' );
            const mobileMenu = H.querySelector( '.site-header' );
            let mobileMenuController = null;
            if ( mobileNavButton ) {
                mobileMenuController = new InteractableController(
                    mobileNavButton,
                    mobileMenu,
                    {
                        className: 'mobile-nav-open',
                        closeOnScroll: true,
                        closeOnOutside: true,
                    }
                );
            }

            /**
             * Initialize the mobile nav menu accordians.
             */
            const accordians = Array.from( H.querySelectorAll( '#site-navigation' ) );
            if ( accordians ) {
                for ( const accordian of accordians ) {
                    accordian.accordianController = new MobileNavigationAccordianMenu( accordian );
                }
            }
        }

        /**
         * Insert Today's Date
         */
        let dateInsertables = Array.from( D.querySelectorAll( '.js-todays-date' ) );
        for ( const insertable of dateInsertables ) {
            insertTodaysDate( insertable );
        }

    }

    W.addEventListener( 'scroll', onScroll, {
        passive: true
    } );

    function onScroll () {

    }

    function initializeGlobalVariables () {
        H.ww = 0; // window width
        H.wh = 0; // window height

    }

    function updateGlobalVariables () {
        H.ww = H.clientWidth || B.clientWidth || W.innerWidth;
        H.wh = W.innerHeight || H.clientHeight;
    }

    function onResize () {
        updateGlobalVariables();

        setRootCssVariables( {
            '--width': H.ww,
            '--height': H.wh,
            '--aspect-ratio': H.ww / H.wh,
            '--inverse-aspect-ratio': H.wh / H.ww,
        } );
    }

    function setRootCssVariables ( variables ) {
        for ( const key in variables ) {
            H.style.setProperty(
                key,
                variables[key]
            );
        }
    }
} )( window, document, document.documentElement, document.body );
